import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { DOCUMENT } from '@angular/platform-browser';
import { Router } from '@angular/router';
// Servicio
import { EmpleadosServicio } from '../../../services/empleado.service';
// Modales
import { AlertasModales } from '../../../helpers/alertasModales';
import { PadronService } from '../../../services/padron.service';

declare var $: any;

@Component({
  selector: 'app-nuevo-empleado',
  templateUrl: './nuevo-empleado.component.html',
  styleUrls: ['./nuevo-empleado.component.css']
})
export class NuevoEmpleadoComponent implements OnInit {
  form: FormGroup;
  errors: any;
  loading: Boolean;
  scrollBottom: number;
  btnValidation: boolean;
  btnFixed: string;
  cedula_encontrada = false;
  mask = { mask: '000-0000000-0', len : 13};
  constructor(
    public empleadoService: EmpleadosServicio,
    private alerts: AlertasModales,
    private padron: PadronService,
  ) {
    // Inicializar el formulario
    this.form = new FormGroup({
      'nombre': new FormControl('', Validators.required),
      'apellido': new FormControl('', Validators.required),
      'cedula': new FormControl('', [ Validators.required, Validators.min(1), Validators.maxLength(9999999999) ] ),
      'telefono': new FormControl(''),
      'estado_civil': new FormControl(''),
      'celular': new FormControl(''),
      'direccion': new FormControl(''),
      'puesto': new FormControl('', Validators.required),
      'sueldo': new FormControl(''),
      'fecha_ingreso': new FormControl(''),
      'correo': new FormControl('', [Validators.required, Validators.email]),
      'usuario': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required, Validators.minLength(6)]),
      're_password': new FormControl('')
    });

    this.form.get('re_password').setValidators([
      Validators.required,
      this.verificarPasswords.bind(this),
      Validators.minLength(6)
    ]);
  }

  ngOnInit() {
    // Inicializar las variables btnFixed & scrollBottom;
    this.scrollBottom = $('#scroll-medium').offset().top;
  }

  verificarPasswords(control: FormControl): {[s: string]: boolean} {
    if (control.value !== this.form.get('password').value) {
      return {
        // password no coinciden
        checkPass: true
      };
    }
    // password coinciden
    return null;
  }

  onWindowScroll() {
    const number = document.body.scrollTop || document.documentElement.scrollTop || 0;

    if ( number > this.scrollBottom && (this.errors && this.errors.hasOwnProperty('cedula') ) ) {
      this.btnValidation = true;
      this.btnFixed = 'up';
    } else if (number < this.scrollBottom
      && (this.errors && (this.errors.hasOwnProperty('usuario') || this.errors.hasOwnProperty('password')))) {
      this.btnValidation = true;
      this.btnFixed = 'down';
    } else {
      this.btnValidation = false;
    }
  }

  scrollToDiv() {
    $('html, body').animate({
      scrollTop: (this.btnFixed === 'up' ? $('#cedula').parent().parent().offset().top : $(document).height())
    }, 500);
  }

  removeError(formControlName: string) {
    switch (formControlName) {
      case 'cedula':
        if (this.errors && this.errors.hasOwnProperty('cedula')) {
          delete this.errors.cedula;
        }
      break;
      case 'usuario':
        if (this.errors && this.errors.hasOwnProperty('usuario')) {
          delete this.errors.usuario;
        }
      break;
      case 'password':
        if (this.errors && this.errors.hasOwnProperty('password')) {
          delete this.errors.password;
        }
      break;
    }
  }

  registrarEmpleado() {
    if (this.form.valid) {
      $('button:submit').prop('disabled', true).html(`<i class="fa fa-circle-o-notch fa-spin"></i> Creando Empleado`);
      this.empleadoService.crearEmpleado(this.form.value).subscribe(res => {
        if (res) {
          this.alerts.correctoModalJquery('EMPLEADO REGISTRADO CON ÉXITO', 'green', 'modern', 'fa fa-user');
          // tslint:disable-next-line:forin
          for (const key in this.form.controls) {
            this.form.get(key).setValue('');
            this.form.get(key).markAsUntouched();
          }
        }
        $('button:submit').prop('disabled', false).html(`Crear Empleado`);
      }, err => {
        if (err) {
          if (err.error.hasOwnProperty('required')) {
            this.alerts.validacionesModalJquery('Error de validación', err.error.required, 'red');
          } else {
            this.errors = err.error;
          }
        }

        $('button:submit').prop('disabled', false).html(`Crear Empleado`);
      });
    }
  }

  obtenerUsuario() {
    if (this.form.get('nombre').value !== '' && this.form.get('apellido').value !== '') {
      this.empleadoService.obtenerUsuario(this.form.get('nombre').value, this.form.get('apellido').value)
      .subscribe( res => this.form.get('usuario').setValue(res));
    }
  }
  cedulaChange(event) {
    // this.form.get('cedula').setValue(event.target.value);
    //   this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
    // this.form.get('cedula').markAsTouched();
    // this.form.get('cedula').updateValueAndValidity();

    this.form.get('cedula').setValue(event.target.value);
    this.form.get('cedula').clearValidators();
    this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
    if ( this.form.get('cedula').value.length - 2 === 11) {
    this.searchCedula();
    } else {
      this.form.get('nombre').setValue('');
      this.form.get('apellido').setValue('');
      this.cedula_encontrada = false;
    }
    this.form.get('cedula').markAsTouched();
    this.form.get('cedula').updateValueAndValidity();
  }

  searchCedula() {
    this.padron.getCedula(this.form.get('cedula').value)
    .subscribe( (res: any) => {
      if (res) {
        this.form.get('nombre').setValue(res.data.nombre);
        this.form.get('apellido').setValue(res.data.apellidos);
        this.obtenerUsuario();
        this.cedula_encontrada = true;
        this.obtenerUsuario();
      }
    }, () => {
      this.form.get('nombre').setValue('');
      this.form.get('apellido').setValue('');
      this.cedula_encontrada = false;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/empleado/nuevo/nuevo-empleado.component.ts